"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWrapper = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const react_laag_1 = require("react-laag");
const components_1 = require("./InputElement/components");
function Affix({ children, type }) {
    return typeof children === 'string' ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ "data-type": type }, { children: children }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }));
}
exports.InputWrapper = (0, react_1.forwardRef)((_a, ref) => {
    var { children, prefix, suffix } = _a, rest = __rest(_a, ["children", "prefix", "suffix"]);
    const focusRef = (0, react_1.useRef)(null);
    const focusInput = () => { var _a; return (_a = focusRef.current) === null || _a === void 0 ? void 0 : _a.focus(); };
    const paddingBoxStyle = (0, react_1.useMemo)(() => (0, app_1.css) `
        ${prefix && typeof prefix !== 'string' && 'padding-left: inherit'};
        ${suffix && 'padding-right: inherit'};
      `, [prefix, suffix]);
    return ((0, jsx_runtime_1.jsxs)(components_1.InputWrap, Object.assign({ onClick: focusInput, "$hasPrefix": Boolean(prefix), "$hasSuffix": Boolean(suffix) }, rest, { children: [(0, jsx_runtime_1.jsx)(Affix, Object.assign({ type: "prefix" }, { children: prefix })), (0, jsx_runtime_1.jsx)(components_1.PaddingBox, Object.assign({ css: paddingBoxStyle }, { children: (0, react_1.cloneElement)(children, { ref: (0, react_laag_1.mergeRefs)(ref, focusRef) }) })), (0, jsx_runtime_1.jsx)(Affix, Object.assign({ type: "suffix" }, { children: suffix }))] })));
});
